module.exports = __webpack_public_path__ + "static/media/logo.bc785d11.png";